import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { User } from '../interfaces';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class TokenStorageService {
  private readonly userKey = 'user';
  private readonly tokenKey = 'token';

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  isBrowser = false;
  get storage() {
    if (this.isBrowser) {
      return sessionStorage;
    } else {
      return null;
    }
  }

  clearStorage() {
    if (this.storage) {
      this.storage.removeItem(this.userKey);
      this.storage.removeItem(this.tokenKey);
    }
  }

  saveToken(token: string) {
    if (this.storage) {
      this.storage.removeItem(this.tokenKey);
      this.storage.setItem(this.tokenKey, token);
    }
  }

  getToken(): string | null {
    if (this.storage) {
      return this.storage.getItem(this.tokenKey);
    } else {
      return null;
    }
  }

  saveUser(user: User) {
    if (this.storage) {
      this.storage.removeItem(this.userKey);
      this.storage.setItem(this.userKey, JSON.stringify(user));
    }
  }

  getUser(): User | null {
    const key = this.storage ? this.storage.getItem(this.userKey) : null;
    if (key) {
      return JSON.parse(key);
    } else {
      return null;
    }
  }

  isAuthenticated(): boolean {
    const token = this.getToken();
    if (token) {
      return JSON.parse(token);
    } else {
      return false;
    }
  }
}
